import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import SourceRepository from '@/services/repository/SourceRepository';
import VueUtilities from '@/services/VueUtilities';
import { PredefinedTextLogger } from '@/entities/models/Annotation';
import AppConfig from '@/configLoader';
var sourceRepository;
let DiscardLoggerModal = class DiscardLoggerModal extends Vue {
    constructor() {
        super(...arguments);
        this.PredefinedTextLogger = PredefinedTextLogger;
        this.createAnnotation = true;
        this.customAnnotationText = '';
        this.predefinedAnnotationText = PredefinedTextLogger.UNASSIGN;
    }
    /**
     * Check config if feature is On.
     */
    get annotateLogerStateChangeIsTurnedOn() {
        return AppConfig.getConfig().features.annotate_logger_state_change == true;
    }
    get annotationTexts() {
        return Object.values(PredefinedTextLogger).filter((x) => x == PredefinedTextLogger.OWN || x == PredefinedTextLogger.UNASSIGN);
    }
    created() {
        sourceRepository = new SourceRepository(this);
    }
    resultRetrieved() {
        this.$emit('modalClosed');
    }
    async saveChanges() {
        let result = await sourceRepository.unassignLogger(this.source.id, this.createAnnotation
            ? this.$t(`component.report.create_annotation.predefined.${this.predefinedAnnotationText}`).toString()
            : '');
        if (result.logger == null) {
            VueUtilities.openSuccessToast(this, this.$t('component.logger.change_modal.confirmDiscardDialog.success'));
            this.resultRetrieved();
            this.$emit('reloadSource');
        }
        else {
            VueUtilities.openErrorToast(this, this.$t('component.logger.change_modal.confirmDiscardDialog.failure'));
        }
    }
};
__decorate([
    Prop({ type: Object })
], DiscardLoggerModal.prototype, "source", void 0);
__decorate([
    Prop({ type: Boolean })
], DiscardLoggerModal.prototype, "annotateLogerStateChange", void 0);
DiscardLoggerModal = __decorate([
    Component
], DiscardLoggerModal);
export default DiscardLoggerModal;
